<template>
    <div class="simple-row">
        <div class="left">
            <div class="file-upload-label" v-if="lableText != null">{{lableText}}</div>
            <div class="file-upload-label" v-if="assetNatureFlag">
                <el-select v-model="assetNature" collapse-tags placeholder="请选择" @change="assetNatureChange">
                    <el-option v-for="item in assetNatureList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                </el-select>
            </div>
            <swb-file-upload :fileFor="fileFor" :custData="custFileds" :usage="usage" :fileGroup="fileGroup" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="multipleFile"></swb-file-upload>
        </div>
        <div class="right">
            <a class="swb-btn swb-btn-link" @click="downloadTemplate" v-if="downloadUrl != null || (downloadFunc != null && typeof downloadFunc == 'function')">{{downloadText}}</a>
            <a class="swb-btn swb-btn-link" @click="downloadDesc" v-if="downloadDescTxt">导入说明</a>
        </div>
    </div>


</template>


<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import merchtComnApi from '../../api/merchtComn'

    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);

    export default{
        name: 'swb-file-upload-group',
        desc: '通用文件上传',
        props: {
            //文件细分场景用途
            fileFor: {
                type: String,
                default: null
            },
            fileGroup: {
                type: String,
                default: null
            },
            multipleFile: {
                type: Boolean,
                default: false
            },
            downloadUrl: {
                type: String,
                default: null
            },
            downloadFunc: {
                type: Function
            },
            showFormatElpx: {
                type: Function
            },
            custFileds: {
                type: String,
                default: null
            },
            usage: {
                type: String,
                default: null
            },
            lableText: {
                type: String,
                default: null
            },
            downloadText: {
                type: String,
                default: "下载模板"
            },
            assetNatureFlag: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            usage(newVal, oldVal){

            }
        },
        data: function () {
            return {
                downloadDescTxt: false,
                assetNatureList: [],
                assetNature: 0
            }
        },
        created: function () {
            if(!Utils.isNoB(this.showFormatElpx) && typeof this.showFormatElpx == 'function') {
                this.downloadDescTxt = true;
            } //
            let assetNatureList = getEnumList("assetNature");
            let assetNatures = [];
            assetNatureList.forEach(function (item) {
                if(item.value == 0) {
                    item.text = '通用导入';
                    assetNatures.push(item);
                } else {
                    assetNatures.push(item);
                }
            });
            this.assetNatureList = assetNatures;
        },
        methods: {
            assetNatureChange(){
                this.$emit('notity-nature-change', this.assetNature);
            },
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('请选择要上传的文件');
                    return false;
                }
                this.theLoader = MsgBox.loading("正在解析文件");
            },
            //上传进度处理
            onProgress: function (progress) {
                let percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                this.theLoader.hide();
                if(result.type === 'info') {
                    //
                    result.assetNature = this.assetNature;
                    this.$emit('notity-upload-done', result);
                } else {
                    MsgBox.warning(result.message);
                }
            },
            downloadTemplate: function () {
                let downloadUrl = this.downloadUrl;
                let downloadFunc = this.downloadFunc;
                if(downloadUrl != null) {
                    // 下载模版
                    if(this.assetNatureFlag) {
                        Utils.setPageUrl(getAppUrl(downloadUrl + '&usage=' + this.usage), '_blank');
                    } else {
                        Utils.setPageUrl(getAppUrl(downloadUrl), '_blank');
                    }
                } else if(downloadFunc != null && typeof downloadFunc == 'function') {
                    this.downloadFunc();
                }
            },
            downloadDesc: function () {
                // let downloadDescTxt = this.downloadDescTxt;
                this.showFormatElpx();
            }
        }
    }
</script>

<style>
    .file-upload-label {
        float: left;
        padding-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/comn/FileUploadGroupDlg.vue